import { ArrowRight, LightBulb, PhoneLocked, Quotes } from '@/client/components/icons/ContinuIcons';
import { HStack, Stack, Text, VStack } from '@chakra-ui/react';

import AIAgentIconShadow from './AIAgentIconShadow';
import SolidButton from '@/client/components/shared/buttons/SolidButton';
import { useAIAgentStore } from './AIAgentStore';
import { useTranslation } from 'react-i18next';

export default function AIAgentWelcome() {
  const { t } = useTranslation();
  const { setShowWelcome } = useAIAgentStore();

  const welcomeOptions = [
    {
      label: t('aiAgent.welcome.one.label'),
      helpText: t('aiAgent.welcome.one.helpText'),
      icon: <Quotes boxSize={4} />,
    },
    {
      label: t('aiAgent.welcome.two.label'),
      helpText: t('aiAgent.welcome.two.helpText'),
      icon: <PhoneLocked boxSize={6} />,
    },
    {
      label: t('aiAgent.welcome.three.label'),
      helpText: t('aiAgent.welcome.three.helpText'),
      icon: <LightBulb boxSize={6} />,
    },
  ];

  return (
    <VStack spacing={10} overflowY="auto">
      <AIAgentIconShadow
        text={t('aiAgent.welcome.hello')}
        helpText={t('aiAgent.welcome.hello.helpText')}
      />

      <VStack spacing={8}>
        {welcomeOptions.map((option) => (
          <HStack key={option.label} spacing={4} paddingX={8} alignItems="flex-start">
            {option.icon}

            <Stack spacing={2}>
              <Text fontSize="16px" fontWeight={500} color="baseBlack">
                {option.label}
              </Text>

              <Text fontSize="14px" fontWeight={500} color="neutral.800">
                {option.helpText}
              </Text>
            </Stack>
          </HStack>
        ))}

        <SolidButton
          variant="AIAgent"
          rightIcon={<ArrowRight />}
          onClick={() => setShowWelcome(false)}
        >
          {t('aiAgent.welcome.gotIt')}
        </SolidButton>
      </VStack>
    </VStack>
  );
}
